import { Icon } from '@natera/material/lib/icon'
import { xor } from 'lodash-es'
import { Chip, Popover, PopoverContent, PopoverTrigger, Text } from '~/shared/ui'
import type { PinnableDocumentFilterKey } from '../../model'
import { usePinnedFilters } from '../../model'

export function FilterChip({
  children,
  filterKey,
  label,
  hasValue,
  onClose,
  dropdownContent,
  pinned,
  mode,
}: {
  children: React.ReactNode
  filterKey: PinnableDocumentFilterKey
  label: string
  hasValue: boolean
  onClose: () => void
  dropdownContent: React.ReactNode
  pinned: boolean
  mode: 'pinned' | 'unpinned'
}) {
  const { pinnedFilters, setPinnedFilters } = usePinnedFilters()

  if (mode === 'unpinned' && (!hasValue || pinned)) return null
  if (mode === 'pinned' && !pinned) return null

  return (
    <Popover>
      <PopoverTrigger className="h-fit border-none bg-transparent p-0">
        <Chip
          outlined
          selected={hasValue}
          onClose={hasValue ? onClose : undefined}
          dropdown
        >
          {hasValue ? children : label}
        </Chip>
      </PopoverTrigger>
      <PopoverContent
        className="py-1"
        align="start"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <div className="flex items-center gap-[11px] px-3 py-3">
          <button
            type="button"
            className="cursor-pointer border-none bg-transparent p-0"
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              setPinnedFilters(xor(pinnedFilters, [filterKey]))
            }}
          >
            <Icon
              className="text-primary-main ml-0.5 text-[20px]"
              children="keep"
              fill={pinned}
            />
          </button>
          <Text appearance="SUBTITLE2">{label}</Text>
        </div>
        {dropdownContent}
      </PopoverContent>
    </Popover>
  )
}
